import { render, staticRenderFns } from "./FlappyGame.vue?vue&type=template&id=6acfa8a0&"
import script from "./FlappyGame.vue?vue&type=script&lang=ts&"
export * from "./FlappyGame.vue?vue&type=script&lang=ts&"
import style0 from "./FlappyGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports